export default __webpack_public_path__ + "assets/png/c7b0158ed28fae3f93dec79c43a1c0e9.png";